import script from "./InfoBar.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoBar.vue?vue&type=script&setup=true&lang=js"

import "./InfoBar.vue?vue&type=style&index=0&id=3b357766&lang=less"

const __exports__ = script;

export default __exports__